




import {
  createComponent,
  computed,
  ref,
  onMounted,
} from "@vue/composition-api";
import { Input } from "element-ui";

interface Props {
  value: any;
  inputComponent: any;
  inputTransform: (input: any) => any;
  valueTransform: (value: any) => any;
}

export default createComponent<Props>({
  components: {},
  props: {
    value: { required: true },
    inputComponent: { default: () => Input },
    inputTransform: { default: () => (input: any) => input },
    valueTransform: { default: () => (value: any) => value },
  },
  setup(props, ctx) {
    const transformedValue = computed(() => props.valueTransform(props.value));

    const onInput = (inputValue: any) => {
      ctx.emit("input", props.inputTransform(inputValue));
    };

    return { transformedValue, onInput };
  },
});
